export class UrlConstant {
    public static readonly API_VERSION = '/api';

    public static readonly LOGIN = '/auth/login';

    public static readonly LOGOUT = '/auth/logout';

    public static readonly REFRESH_TOKEN = '/refresh-token';

    // ── 2FA ──────────────────────────────────────────────────
    /** Bước 2 login: xác thực OTP + mfaToken → nhận access_token */
    public static readonly VERIFY_MFA = '/auth/verify-mfa';

    /** Lấy trạng thái 2FA của user đang đăng nhập */
    public static readonly MFA_STATUS = '/auth/mfa/status';

    /** Khởi tạo 2FA: sinh secret + QR code URL */
    public static readonly MFA_SETUP = '/auth/mfa/setup';

    /** Xác nhận OTP để kích hoạt 2FA */
    public static readonly MFA_VERIFY_SETUP = '/auth/mfa/verify-setup';

    /** Tắt 2FA (cần xác nhận OTP) */
    public static readonly MFA_DISABLE = '/auth/mfa/disable';

    /**
     * First-login flow: xác nhận user đã quét QR → nhận OAuth2 access_token.
     * POST /auth/verify-mfa-first-login  { mfaToken: firstLoginToken, otp }
     */
    public static readonly VERIFY_MFA_FIRST_LOGIN = '/auth/verify-mfa-first-login';
  }
